export const canPublishMap = () => () => {
    return function () {
        if (! /^(DRAFT|REVISE)$/.test(this.data.mapStsCode)) {
            this.logger.error('只有草稿/修订状态的地图才能发布')
            return false
        }

        if (! this.permission.has('write')) {
            this.logger.error('没有发布权限')
            return false
        }

        return true
    }
}

export const publishMap = () => () => {
    return function () {
        return this.runAction(
            () => this.actions.publishUpgradeMap(),
            {action: '发布地图'},
        )
    }
}
